import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/69fa5858f6558f0014b27eba_1783267580159_14872dd0/deencompanion/node_modules/next/dist/client/app-dir/link.js");
